import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: center;
    margin-top: 10%;
    padding: 24px 16px;

    text-align: center;

    .empty-icon {
        margin-bottom: 12px;
        padding: 16px;

        background: #fff;
        border: 0.5px solid rgba(46, 79, 94, 0.3);
        border-radius: 12px;
        box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
    }
`;
